module.exports = __webpack_public_path__ + "static/media/title-success.a5aa74c3.png";